module.exports = __webpack_public_path__ + "media/images/handwritten_message3-bee0b131.svg";